var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('h1',{staticStyle:{"margin-bottom":"20px","display":"flex","align-items":"center"}},[_vm._v("\n            Fulfillment\n        ")]),_vm._v(" "),_c('div',[_vm._t("search-input"),_vm._v(" "),_vm._t("buttons")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }